<template>
  <v-layout row class="pl__chat">
    <div class="pl-card-block-channel left-menu">
      <form action="#" class="search">
        <v-icon class="pos-absolute img_search-chat"> search </v-icon>

        <v-icon class="pos-absolute img_add-chat" @click="dialog = true"> add </v-icon>

        <input v-model="searchField" placeholder="Искать пользователя/чат" type="search" name="" id="" />
        <input type="submit" value="" />
      </form>

      <menu v-if="searchChannels.length <= 0" class="list-friends">
        <li
          v-for="(chat, index) in chats"
          :key="index"
          :class="{ active: chat.alias === activeChat }"
          @click="changeChat(chat)"
        >
          <!--<img width="50" height="50" src="http://cs625730.vk.me/v625730358/1126a/qEjM1AnybRA.jpg">-->
          <div class="userInfo">
            <div class="user">
              {{ getChatName(chat) }}
            </div>
            <!--<div class="status on"> online</div>-->
          </div>
        </li>

        <li />
      </menu>

      <menu v-else class="list-friends search-results">
        <li
          v-for="employer in searchChannels"
          :key="employer.id"
          :class="{ active: 'private:' + employer.id === activeChat }"
          @click="changePrivateChat(employer.id)"
        >
          <!--<img width="50" height="50" src="http://cs625730.vk.me/v625730358/1126a/qEjM1AnybRA.jpg">-->
          <div class="userInfo">
            <div class="user">{{ employer.first_name }} {{ employer.last_name }}</div>
            <!--<div class="status on"> online</div>-->
          </div>
        </li>
      </menu>
    </div>

    <v-layout class="pl-card-block-log" justify-space-between column>
      <div class="chat">
        <div class="top">
          <!--<div class="userImage">-->
          <!--<img width="50" height="50" src="http://cs625730.vk.me/v625730358/1126a/qEjM1AnybRA.jpg">-->
          <!--</div>-->
          <div class="userInfo">
            <div class="name">
              {{ activeChatName }}
            </div>

            <div v-show="addEmployersToChatBtn" class="addToChat">
              <a href="javascript:void(0);" @click="addEmployersModal = true"> Добавить участников </a>
            </div>
          </div>

          <i class="fa fa-star" />
        </div>

        <chat-log :messages="messages" :employerData="employerData" />

        <chat-composer :employerData="employerData" @messagesent="addMessage" />
      </div>
    </v-layout>

    <v-dialog v-model="dialog" max-width="450">
      <v-card v-if="activeSectionCreatedChat === 'selectEmployer'">
        <v-card-title class="v-card__title pl-dialog__title"> Добавьте сотрудников </v-card-title>

        <v-layout row wrap class="mt-3">
          <v-autocomplete
            v-model="employersSelected"
            :items="employersSearched"
            :loading="isLoading"
            :hide-no-data="employersSelected.length === 0"
            :no-data-text="'Сотрудников не найдено'"
            :cache-items="true"
            :multiple="true"
            :search-input.sync="search"
            style="width: 90%"
            class="pl-autocomplete ml-3 mr-3"
            label="ФИО Сотрудника"
            item-text="name"
            item-value="id"
            autocomplete
            hide-selected
            chips
            return-object
            small-chips
          >
            <template slot="selection" slot-scope="data">
              <v-chip :selected="data.selected" close class="chip--select-multi" @input="remove(data.item)">
                <v-avatar>
                  <img :src="`http://i.pravatar.cc/100?u=${data.item.id}`" class="avatar_placeholder" />
                </v-avatar>

                {{ data.item.name }}
              </v-chip>
            </template>

            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item" />
              </template>

              <template v-else>
                <v-list-tile-avatar>
                  <img :src="`http://i.pravatar.cc/100?u=${data.item.id}`" class="avatar_placeholder" />
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.name" />
                  <v-list-tile-sub-title v-html="data.item.group" />
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>

          <v-layout class="pl-schedule-dialog-units-footer mt-3" justify-end>
            <v-btn @click="activeSectionCreatedChat = 'employersIsSelected'"> Далее </v-btn>
          </v-layout>
        </v-layout>
      </v-card>
      <v-card v-else>
        <v-card-title class="v-card__title pl-dialog__title"> Здесь можно создать группу </v-card-title>

        <v-layout row wrap justify-center>
          <v-flex>
            <v-text-field v-model="chatName" style="width: 90%" class="mt-2 ml-3" label="Название группы" />
          </v-flex>

          <v-card-text>
            <v-radio-group v-model="chatType">
              <v-radio :value="0" label="Публичная группа" color="primary" />
              <v-radio :value="1" label="Приватная группа" color="primary" />
            </v-radio-group>
          </v-card-text>
        </v-layout>

        <v-layout class="pl-schedule-dialog-units-footer justify-end">
          <v-btn :loading="loadingCreateChat" @click="createChannel"> Создать </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addEmployersModal" max-width="450">
      <v-card>
        <v-card-title class="v-card__title pl-dialog__title"> Добавьте сотрудников </v-card-title>

        <v-layout column wrap class="mt-3">
          <v-autocomplete
            v-model="employersSelected"
            :items="employersSearched"
            :loading="isLoading"
            :cache-items="true"
            :no-data-text="'Сотрудников не найдено'"
            :hide-no-data="employersSelected.length === 0"
            :multiple="true"
            :search-input.sync="searchEmployer"
            style="width: 90%"
            class="pl-autocomplete ml-3"
            label="ФИО Сотрудника"
            item-text="name"
            item-value="id"
            autocomplete
            hide-selected
            chips
            return-object
            small-chips
          >
            <template slot="selection" slot-scope="data">
              <v-chip :selected="data.selected" class="chip--select-multi" close @input="remove(data.item)">
                <v-avatar>
                  <img :src="`http://i.pravatar.cc/100?u=${data.item.id}`" class="avatar_placeholder" />
                </v-avatar>

                {{ data.item.name }}
              </v-chip>
            </template>

            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item" />
              </template>

              <template v-else>
                <v-list-tile-avatar>
                  <img :src="`http://i.pravatar.cc/100?u=${data.item.id}`" class="avatar_placeholder" />
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.name" />
                  <v-list-tile-sub-title v-html="data.item.group" />
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>

          <v-layout class="pl-schedule-dialog-units-footer mt-3" justify-end>
            <v-btn
              :disabled="employersSelected.length === 0"
              :loading="loadingAddEmployerToChat"
              @click="addEmployersToThisChat"
            >
              Добавить
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import ChatLog from '@/components/Chat/ChatLog.vue'
import ChatComposer from '@/components/Chat/ChatComposer.vue'
import request from '@/helpers/request'

export default {
  name: 'Chat',
  components: {
    ChatLog,
    ChatComposer,
  },
  computed: {
    ...mapGetters(['user']),
  },
  data: () => ({
    messages: [],
    usersInRoom: [],
    employerData: {},
    activeChat: '',
    activeChatName: '',
    chats: [],
    searchChannels: [],
    searchField: '',
    dialog: false,
    chatName: '',
    chatType: 0,
    loadingCreateChat: false,
    activeSectionCreatedChat: 'selectEmployer',
    select: 'Programming',
    items: ['Programming', 'Design', 'Vue', 'Vuetify'],
    employersSelected: [],
    employersSearched: [],
    search: null,
    searchEmployer: null,
    isLoading: false,
    addEmployersModal: false,
    loadingAddEmployerToChat: false,
    addEmployersToChatBtn: false,
  }),
  created() {
    this.employerData = this.user

    window.EchoChat.private(`newchat.${this.employerData.id}`).listen('StoreNewPrivateChat', e => {
      this.getChatList(this.activeChat)
    })

    this.getChatList()
  },
  methods: {
    remove(item) {
      this.employersSelected = this.employersSelected.filter(employer => employer.id !== item.id)
    },
    addEmployersToThisChat() {
      this.loadingAddEmployerToChat = true

      request(
        'POST',
        `${this.$config.server}/${this.$config.modules.crm.api.chat.addEmployers}`,
        {
          chat_id: this.activeChat,
          employer_ids: _.map(this.employersSelected, 'id'),
        },
        true,
      )
        .then(() => {
          this.addEmployersModal = false
          this.employersSelected = []
          this.loadingAddEmployerToChat = false
        })
        .catch(() => {})
    },
    createChannel() {
      this.loadingCreateChat = true

      request(
        'POST',
        `${this.$config.server}/${this.$config.modules.crm.api.chat.create}`,
        {
          name: this.chatName,
          type: this.chatType,
          employer_ids: _.map(this.employersSelected, 'id'),
        },
        true,
      )
        .then(
          ({
            data: {
              data: { alias },
            },
          }) => {
            this.getChatList(alias)
            this.dialog = false
            this.employersSelected = []
            this.chatName = ''
            this.loadingCreateChat = false
            this.activeSectionCreatedChat = 'selectEmployer'
          },
        )
        .catch(() => {})
    },
    getChatName(chat) {
      if (chat.type !== 2) {
        return `#${chat.name}`
      }

      if (chat.employers[0].id === this.employerData.id) {
        return `@${chat.employers[1].first_name} ${chat.employers[1].last_name}`
      } else {
        return `@${chat.employers[0].first_name} ${chat.employers[0].last_name}`
      }
    },
    changeChat(chat) {
      this.activeChat = chat.alias
      this.activeChatName = this.getChatName(chat)
      this.addEmployersToChatBtn = chat.type !== 2
    },
    changePrivateChat(employerId) {
      const searchEmployee = this.searchChannels.find(employer => employer.id === employerId)

      this.activeChat = `private:${employerId}`
      this.activeChatName = `@${searchEmployee.first_name} ${searchEmployee.last_name}`
    },
    addMessage(message) {
      this.messages.push(message)

      if (this.activeChat.includes('private:')) {
        request(
          'POST',
          `${this.$config.server}/${this.$config.modules.crm.api.chat.create}`,
          {
            name: this.activeChat,
            type: 2,
            employer_ids: [this.activeChat.replace('private:', '')],
          },
          true,
        )
          .then(
            ({
              data: {
                data: { alias },
              },
            }) => {
              this.getChatList(alias)
              this.storeMessage(alias, message)
              this.dialog = false
              this.chatName = ''
              this.loadingCreateChat = false
            },
          )
          .catch(() => {})
      } else {
        this.storeMessage(this.activeChat, message)
      }
    },
    storeMessage(activeChat, message) {
      this.$store
        .dispatch('STORE_MESSAGES', {
          message: message.message,
          channel: activeChat,
          attachments: message.attachments,
        })
        .then(({ data: { data } }) => {
          this.getChatList(data)
          this.searchChannels = []
          this.searchField = ''
          this.activeChat = data
        })
    },
    getChatList(chatId = null) {
      request('GET', `${this.$config.server}/${this.$config.modules.crm.api.chat.getChatList}`, {}, true)
        .then(({ data: { data } }) => {
          this.chats = _.orderBy(data, ['updated_at'], ['desc'])
          this.activeChat = chatId !== null ? chatId : _.first(this.chats).alias

          if (chatId === null) {
            const firstChat = _.first(this.chats)
            this.activeChatName = this.getChatName(firstChat)
            this.addEmployersToChatBtn = firstChat.type !== 2
          }

          this.getChatLog(this.activeChat)
        })
        .catch(() => {})
    },
    getChatLog(channel) {
      request(
        'GET',
        `${this.$config.server}/${this.$config.modules.crm.api.chat.get}?channel=${channel}`,
        {},
        true,
      ).then(({ data: { data, result } }) => {
        if (result === 'success') {
          this.messages = data
        }
      })
    },
    searchEmployee(val) {
      if (val.length <= 3) {
        return
      }

      request(
        'POST',
        `${this.$config.server}/${this.$config.modules.crm.api.chat.searchEmployee}`,
        { search: val },
        true,
      ).then(({ data: { data, result } }) => {
        if (result === 'success') {
          this.searchChannels = data
        }
      })
    },
    changeEmployersSearched(value) {
      // Items have already been requested
      if (value === '' || value === null) {
        return
      }
      if (this.isLoading) {
        return
      }

      this.$store
        .dispatch('SEARCH_EMPLOYEE', val)
        .then(({ data: { data, result } }) => {
          if (result === 'success') {
            this.employersSearched = _.forEach(_.cloneDeep(data.items.data), employer => {
              const firstName = employer.first_name || ''
              const lastName = employer.last_name || ''
              const phone = employer.phone ? employer.phone.substr(-4) || '' : ''

              employer.name = `${firstName} ${lastName} ${phone}`
            })
          }
        })
        .finally(() => (this.isLoading = false))
    },
  },
  watch: {
    search(val) {
      this.changeEmployersSearched(val)
    },
    searchEmployer(val) {
      this.changeEmployersSearched(val)
    },
    searchField(newSearch) {
      if (newSearch.length === 0) {
        this.searchChannels = []
      }

      this.searchEmployee(newSearch)
    },
    activeChat(newChat, oldVal) {
      if (oldVal !== '') {
        window.EchoChat.leave(`chatroom.${oldVal}`)
      }

      window.EchoChat.private(`chatroom.${newChat}`).listen('MessagePosted', e => {
        this.messages.push({
          message: e.message,
          employer: e.employer,
        })
      })

      this.getChatLog(newChat)
    },
  },
}
</script>
